// extracted by mini-css-extract-plugin
export default {"container":"container--2Q8P9fQ","intro":"intro--2xJhBEA","introImg":"introImg--qbKt6zY","icon":"icon--3LQAUbl","main":"main--2PkCjjq"};